/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLightningBolt: {
  name: 'lightning_bolt';
  data: string;
} = {
  name: 'lightning_bolt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path stroke="#000" stroke-miterlimit="10" d="M492.417 955.35h38.25v-62.156l38.25 90.844h-38.25v62.156l-38.25-90.844z" transform="matrix(-3.75 0 0 3.75 2296 -3330.358)"/></svg>`,
};
